var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M949 139L949 167",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 949.5,
    cy: 134.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M944.987 134.19C944.987 130.283 948.288 127.117 952.358 127.117C952.943 127.117 953.511 127.184 954.056 127.308C952.742 126.48 951.187 126 949.519 126C944.814 126 941 129.806 941 134.5C941 139.194 944.814 143 949.519 143C951.814 143 953.895 142.093 955.427 140.62C954.492 141.032 953.454 141.263 952.358 141.263C948.288 141.263 944.987 138.096 944.987 134.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M958.402 133.6L958.37 131.146L956.535 132.719L954.304 132.056L955.112 134.337L953.765 136.381L956.1 136.218L957.499 138.144L958.133 135.763L960.345 134.909L958.402 133.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch3);
export default __webpack_public_path__ + "static/media/church_3.693a923017783b914290f94be5ec2382.svg";
export { ForwardRef as ReactComponent };